/**
 * Monkey-patch attachShadow to inject flex overrides into shopify-accelerated-checkout-cart.
 * Forces buttons to display inline in 2 or 3 columns instead of stacking vertically.
 * Also collapses the intermittent extra wallet row Shopify leaves in Safari (closed shadow DOM).
 * Must run before Shopify's checkout component is defined.
 * Skipped on the /cart page where the full-page cart uses its own layout.
 */
(function () {
  // Skip the patch on the full cart page
  if (document.querySelector('.cart-page') || window.location.pathname === '/cart' || window.location.pathname === '/cart/') return;

  const SHADOW_CSS = `
    .wallet-button-wrapper {
      padding: 0 !important;
      margin: 0 !important;
    }
    .wallet-cart-grid {
      flex-direction: row !important;
      flex-wrap: nowrap !important;
      margin: 0 !important;
      padding: 0 !important;
      gap: 6px !important;
    }
    .wallet-cart-grid .wallet-cart-button-container {
      flex: 1 1 0 !important;
      min-width: 0 !important;
      margin: 0 !important;
    }
    .wallet-cart-grid .wallet-cart-button {
      width: 100% !important;
    }
    .wallet-cart-grid:has(.wallet-cart-button-container:nth-of-type(1):last-of-type) .wallet-cart-button-container {
      flex: 1 1 100% !important;
    }
    /* Shopify sometimes renders a second wallet-cart-grid (Safari first load).
       The extra row is not faded in, but it still occupies space. */
    .wallet-cart-grid ~ .wallet-cart-grid {
      display: none !important;
      height: 0 !important;
      min-height: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      overflow: hidden !important;
      pointer-events: none !important;
    }
  `;

  const HOST_CSS = `
    #cart shopify-accelerated-checkout-cart {
      display: block;
      max-height: var(--shopify-accelerated-checkout-button-block-size, 40px);
      overflow: hidden;
    }
  `;

  function injectDocumentStyle() {
    if (document.getElementById('suri-accelerated-checkout-host')) return;
    const style = document.createElement('style');
    style.id = 'suri-accelerated-checkout-host';
    style.textContent = HOST_CSS;
    document.documentElement.appendChild(style);
  }

  function injectShadowStyle(shadow) {
    if (shadow.querySelector('style[data-suri-checkout-flex]')) return;
    const style = document.createElement('style');
    style.setAttribute('data-suri-checkout-flex', '');
    style.textContent = SHADOW_CSS;
    shadow.appendChild(style);
  }

  function slotHasAssignedContent(slot) {
    return slot.assignedNodes({ flatten: true }).some(function (node) {
      if (node.nodeType === 1) return true;
      return (node.textContent || '').trim().length > 0;
    });
  }

  function collapseEmptyGrids(shadow) {
    var grids = shadow.querySelectorAll('.wallet-cart-grid');
    grids.forEach(function (grid, index) {
      var slots = grid.querySelectorAll('slot');
      if (!slots.length) return;

      var hasAssigned = Array.prototype.some.call(slots, slotHasAssignedContent);

      // Keep the first grid through Safari's upgrade race; hide later empty copies.
      if (index === 0 || hasAssigned) {
        grid.removeAttribute('hidden');
        grid.style.removeProperty('display');
        return;
      }

      grid.setAttribute('hidden', '');
      grid.style.setProperty('display', 'none', 'important');
    });
  }

  function watchShadow(shadow) {
    injectShadowStyle(shadow);
    collapseEmptyGrids(shadow);

    shadow.addEventListener('slotchange', function () {
      collapseEmptyGrids(shadow);
    });

    var observer = new MutationObserver(function () {
      injectShadowStyle(shadow);
      collapseEmptyGrids(shadow);
    });
    observer.observe(shadow, { childList: true, subtree: true });
  }

  injectDocumentStyle();

  var originalAttachShadow = Element.prototype.attachShadow;
  Element.prototype.attachShadow = function (init) {
    var shadow = originalAttachShadow.call(this, init);
    if (this.tagName === 'SHOPIFY-ACCELERATED-CHECKOUT-CART') {
      watchShadow(shadow);
    }
    return shadow;
  };
})();
